<template>
  <span class="user-avatar-icon" role="img" :aria-label="name">
    <span class="user-avatar-icon__initials">{{ initials }}</span>
  </span>
</template>

<script>
export default {
  name: 'UserAvatar',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  computed: {
    initials() {
      return this.name
        .split(' ')
        .filter(Boolean)
        .map((part) => part[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    }
  }
}
</script>
